import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { Context } from "../../../services/context/context_api";
import BodyInformation from "../components/body_information";
import SidebarInformation from "../components/sidebar_information";
import LocationInformation from "../components/location_information";
import Location from "../components/location";
import environment from "../../../environment";
import VideoInformation from "../components/video_information";

if (!localStorage.getItem('isFirstTime')) {
  localStorage.setItem('isFirstTime', JSON.stringify(true));
}

function ProjectDetail() {
  const { actions } = useContext(Context)
  const { id } = useParams();
  const [property, setProperty] = useState({})
  const [errorMsj, setErrorMsj] = useState(null)

  const getProperty = async () => {
    actions.setIsFetching(true)

    const axios = require('axios');
    axios.get(`${environment.ENDPOINT_CAPIRENTBACKEND}/portal/${id}`)
      .then(function (response) {
        // handle success
        const data = response.data
        setProperty({'data':data})

      })
      .catch(function (error) {
        // handle error
        return setErrorMsj('¡Hubo un error. Regresa al listado e intentalo nuevamente!')
      })
      .then(function () {
        // always executed
        actions.setIsFetching(false)
        window.scrollTo(0, 0);
      });
  }

  useEffect(() => {
    getProperty();
    // eslint-disable-next-line
  }, [])

  return (

    <div className="container mt-5">
      {errorMsj ? (
        <div className={'mt-3 alert fade show alert-warning'} role="alert">
          <strong>{errorMsj}</strong>
        </div>
      )
        :
        <>
          <LocationInformation property={property} />
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-12 order-sm-last order-md-first order-lg-first mt-4 mt-md-0">
                <BodyInformation property={property} />
              </div>
              <div className="col-md-4 col-12 pr-0 order-sm-first order-md-last order-lg-last pt-4 pt-md-0 pb-4 pb-md-0">
                {(property?.data?.video_url && property?.data?.video_url !== '') && (
                  <VideoInformation url={property?.data?.video_url} />
                )}
                {property?.data?.address &&
                  <Location property={property} />
                }
                <SidebarInformation property={property} />
              </div>
            </div>
          </div>
        </>
      }
    </div>
  );
}
export default ProjectDetail;
